import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { User, Check, AlertCircle, ChevronRight } from 'lucide-react';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
type Role = 'learner' | 'parent' | 'teacher';
interface RegisterNameStepProps {
  role: Role;
  name: string;
  onNameChange: (value: string) => void;
  usernameAvailable: boolean;
  suggestedUsername: string;
  slideVariants: Record<string, unknown>;
}
export function RegisterNameStep({
  role,
  name,
  onNameChange,
  usernameAvailable,
  suggestedUsername,
  slideVariants
}: RegisterNameStepProps) {
  return <motion.div key="step-name" custom={1} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
    duration: 0.3
  }} className="space-y-5" data-id="element-439">
      <h2 className="text-xl font-black text-slate-900 text-center" data-id="element-440">
        {role === 'learner' ? 'Hoe heet je?' : 'Wat is je naam?'}
      </h2>

      <div data-id="element-441">
        <label className="block text-sm font-bold text-slate-600 mb-1.5" data-id="element-442">
          {role === 'learner' ? 'Voornaam' : 'Volledige naam'}
        </label>
        <div className="relative" data-id="element-443">
          <Input type="text" required autoFocus value={name} onChange={e => onNameChange(e.target.value)} icon={<User className="w-5 h-5" data-id="element-445" />} className="bg-slate-50 border-2 border-slate-200 rounded-2xl focus:bg-white focus:border-orange-400 text-lg font-medium py-4" placeholder={role === 'learner' ? 'bijv. Djayden' : 'bijv. Jan de Vries'} data-id="element-444" />
        </div>
      </div>

      {/* Username preview for learners */}
      <AnimatePresence data-id="element-446">
        {role === 'learner' && name.trim() && <motion.div initial={{
        opacity: 0,
        y: -10,
        height: 0
      }} animate={{
        opacity: 1,
        y: 0,
        height: 'auto'
      }} exit={{
        opacity: 0,
        y: -10,
        height: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-447">
            <div className={`p-4 rounded-2xl border flex items-start gap-3 mt-2 ${usernameAvailable ? 'bg-orange-50 border-orange-100' : 'bg-red-50 border-red-200'}`} data-id="element-448">
              <div className={`mt-0.5 ${usernameAvailable ? 'text-orange-500' : 'text-red-500'}`} data-id="element-449">
                {usernameAvailable ? <Check className="w-5 h-5" data-id="element-450" /> : <AlertCircle className="w-5 h-5" data-id="element-451" />}
              </div>
              <div data-id="element-452">
                <p className={`text-sm font-medium ${usernameAvailable ? 'text-orange-800' : 'text-red-800'}`} data-id="element-453">
                  {usernameAvailable ? 'Je gebruikersnaam wordt:' : 'Deze naam is al bezet:'}
                </p>
                <p className={`text-lg font-black mt-0.5 ${usernameAvailable ? 'text-orange-600' : 'text-red-600'}`} data-id="element-454">
                  {suggestedUsername}
                </p>
                <p className={`text-xs mt-1 ${usernameAvailable ? 'text-orange-600/70' : 'text-red-600/70'}`} data-id="element-455">
                  {usernameAvailable ? 'Hiermee log je straks in.' : 'Probeer een andere naam of voeg je achternaam toe.'}
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>

      <Button type="submit" variant="primary" size="lg" className="w-full" disabled={!name.trim() || role === 'learner' && !usernameAvailable} data-id="element-456">
        Verder <ChevronRight className="w-5 h-5 ml-1" data-id="element-457" />
      </Button>
    </motion.div>;
}